<template>
  <div class="scopes-list">
    <v-banner color="error" dark v-if="fetchError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all <strong>scopes</strong>. You can add, edit or delete scopes. Scopes are used to <strong>protect API endpoints</strong>. You need to add roles for each scope, which is granting to all users, belonging to a group (linked to the role), the permission to have this scope inside his token.</span>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <ScopesTable
        v-on:refresh="fetchAll"
        v-on:createNew="openScopeCreationDialog"
        v-on:editScope="goToDetailedScope"
        v-on:deleteScope="openScopeDeletionDialog"
      />
      <ScopeCreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createScope"
        ref="creationDialog"
      />
      <ScopeDeletionDialog
        :dialog="deletionDialog"
        :scope="selectedScope"
        v-on:cancel="deletionDialog = false"
        v-on:deleteScope="deleteScope"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import mixin from "@/mixins";
import ScopesTable from "@/components/Admin/Scopes/ScopesTable";
import ScopeCreationDialog from "@/components/Admin/Scopes/ScopeCreationDialog";
import ScopeDeletionDialog from "@/components/Admin/Scopes/ScopeDeletionDialog";

export default {
  name: "ScopesList",
  components: {
    ScopesTable,
    ScopeCreationDialog,
    ScopeDeletionDialog
  },
  mixins: [mixin],
  data() {
    return {
      creationDialog: false,
      deletionDialog: false,
      selectedScope: {},
      snackbar: false,
      errorMessage: "",
      displayInfo: false,
    };
  },
  computed: {
    ...mapState({
      fetchError: state => state.scopes.fetchAll.error
    })
  },
  methods: {
    ...mapActions("scopes", { fetchAll: "fetchAll" }),
    ...mapActions("scopes", { createOne: "createOne" }),
    ...mapActions("scopes", { deleteOne: "deleteOne" }),
    openScopeCreationDialog() {
      this.creationDialog = true;
    },
    openScopeDeletionDialog(scope) {
      this.selectedScope = scope;
      this.deletionDialog = true;
    },
    goToDetailedScope(scope) {
      this.$router.push(`/admin/scopes/${scope.uuid}`);
    },
    createScope(name, description) {
      this.createOne({ name: name, description: description })
        .then(() => {
          this.fetchAll();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteScope(uuid) {
      this.deleteOne({ scopeUuid: uuid })
        .then(() => {
          this.fetchAll();
          this.deletionDialog = false;
          this.selectedScope = {};
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>